import { Button } from '@zoopla-eng/zds/button';
import { fontGroups } from '@zoopla-eng/zds/themes';
import { FC, useMemo } from 'react';
import {
    featurePropertyCardWrapperStyle,
    imageStyle,
    propertyDetailsContainerStyle,
    styledCardStyle
} from '../FeaturedProperties.styles.css';
import {
    cardLinkStyle,
    cTAWrapperStyle,
    promoCardDetailsStyle,
    promoCardImageStyle,
    styledPropertyAddressLargeStyle,
    styledPropertyPriceSmallStyle
} from './InternalPromoCard.styles.css';
import { InternalPromoData } from './internalPromoData';

export type Props = {
    promo: InternalPromoData;
    currentSection: 'for-sale' | 'to-rent';
    searchParam?: string;
    onClick?: () => void;
};

const usePromoLink = ({ promo, currentSection, searchParam }: Props) =>
    useMemo(() => {
        if (promo.name === 'smartmap') {
            return `${currentSection}/${promo.link}/${
                searchParam ? searchParam : ''
            }`;
        } else if (promo.name === 'newhomes' && searchParam) {
            return `${promo.link}/${searchParam}`;
        }

        return promo.link;
    }, [promo, currentSection, searchParam]);

const InternalPromoCard: FC<React.PropsWithChildren<Props>> = (props) => {
    const { promo, onClick } = props;

    const link = usePromoLink(props);

    return (
        <div className={featurePropertyCardWrapperStyle}>
            <a
                className={cardLinkStyle}
                href={`/${link}`}
                data-testid="featured-promo"
                onClick={onClick}
            >
                <div className={styledCardStyle}>
                    <div className={promoCardImageStyle}>
                        <img
                            className={imageStyle}
                            src={promo.image.src}
                            alt={promo.image.alt}
                        />
                    </div>
                    <div className={propertyDetailsContainerStyle}>
                        <div className={promoCardDetailsStyle}>
                            <p
                                className={`${styledPropertyPriceSmallStyle} ${fontGroups.mug}`}
                            >
                                {promo.title}
                            </p>
                            <p
                                className={`${styledPropertyAddressLargeStyle} ${fontGroups.fork}`}
                            >
                                {promo.details}
                            </p>
                        </div>
                        <div className={cTAWrapperStyle}>
                            <Button category="secondary" fw>
                                {promo.cta}
                            </Button>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
};

export default InternalPromoCard;
